import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-schemes-delete',
	path: '/secure/admin/DeletePermissionScheme!default.jspa',
};
